import { useState, useEffect, useMemo } from 'react';
import Select from 'react-select';

const DEFAULT_GROUP_ID = 20; // "À répartir"

const GroupSelectCell = ({ item, optionGroups, onGroupChange }) => {
  const groupsKey = (item.groups ?? []).map(g => g.id_group).sort((a, b) => a - b).join(',');

  const defaultOption = useMemo(
    () => optionGroups?.find(o => o.value === DEFAULT_GROUP_ID)
      ?? { value: DEFAULT_GROUP_ID, label: 'À répartir' },
    [optionGroups]
  );

  const buildSelected = () => {
    const mapped = (item.groups ?? []).map(g =>
      optionGroups?.find(o => o.value === g.id_group)
        ?? { value: g.id_group, label: g.lib_group }
    );
    return mapped.length ? mapped : [defaultOption];
  };

  const [selected, setSelected] = useState(buildSelected);

  // Resynchronise uniquement quand les groupes de l'adhérent changent (pas à chaque rendu du parent)
  useEffect(() => {
    setSelected(buildSelected());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupsKey]);

  const handleChange = (options, actionMeta) => {
    console.log('handleChange', actionMeta.action, actionMeta);

    // "À répartir" disparaît dès qu'un vrai groupe est présent
    const real = (options ?? []).filter(o => o.value !== DEFAULT_GROUP_ID);
    setSelected(real.length ? real : [defaultOption]);

    if (actionMeta.action === 'select-option') {
      onGroupChange?.(item, { action: 'add', id_group: actionMeta.option.value });
    } else if (
      actionMeta.action === 'remove-value' || actionMeta.action === 'pop-value'
    ) {
      onGroupChange?.(item, { action: 'remove', id_group: actionMeta.removedValue.value });
    }
  };

  return (
    <Select
      options={optionGroups}
      value={selected}
      isMulti
      isClearable={false}
      onChange={handleChange}
      className="select-group-container"
      classNamePrefix="select-group"
      placeholder="Groupe..."
      isSearchable
      menuPortalTarget={document.body}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
    />
  );
};

export default GroupSelectCell;